import {
  Component, Output, EventEmitter,
} from '@angular/core';

import { DefaultModalComponent } from 'shared/modal/default-modal/default-modal.component';
import { BaseModalComponent } from 'shared/modal/_base-modal.component';


@Component({
  moduleId: module.id,
  selector: 'primary-photo-warning-modal',
  templateUrl: 'primary-photo-warning-modal.component.html',
  styleUrls: ['primary-photo-warning-modal.component.scss'],
})
export class PrimaryPhotoWarningModalComponent extends BaseModalComponent {

  @Output() save: EventEmitter<any> = new EventEmitter();

  @Output() cancel: EventEmitter<any> = new EventEmitter();

  onCancelCLick() {
    this.cancel.emit();
    this.hide();
  }

  onSaveCLick() {
    this.save.emit();
    this.hide();
  }
}
